import type { ToneName } from '@/shared/ui/tones';

/**
 * A cor de cada assunto da parametrizacao, a mesma no cartao do menu e no cartao de
 * entrada da tela do assunto (Endosso e Renovacao). Sao categorias (`tones.ts`): a
 * cor separa um assunto do outro e nao diz nada sobre ele.
 */
export const tomDaParametrizacao = {
  perfilDaCorretora: 'brand',
  modalidades: 'violet',
  consultas: 'cyan',
  endosso: 'indigo',
  renovacao: 'teal',
  taxas: 'rose',
  agravos: 'violet',
} as const satisfies Record<string, ToneName>;
